export const has3rdPartyCookiesEnabled = (): boolean => {
    const thirdPartyCookieKey = 'chkThird'
    const cookie = new Date().valueOf().toString();
    try {
        localStorage.setItem(thirdPartyCookieKey, cookie);
        if (cookie === localStorage.getItem(thirdPartyCookieKey)) {
            return true;
        }
    }
    catch (e) {
        return false;
    }
    return false;
}